<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="subtitle" />
    <!-- Main Content-->
    <main>
        <!-- <el-dialog v-model="dialogTableVisible" :width="dialogWidth">
            <img :src="require('img/' + dialogPic)" style="width: 100%" loading="lazy" />
        </el-dialog> -->
        <div class="container px-4 px-lg-5">
            <div class="row gx-4 gx-lg-5 justify-content-center">
                <div class="col-md-10 col-lg-8 col-xl-8">
                    <el-card style="margin-bottom: 2rem;">
                        <p style="margin-bottom:1rem">展示方式</p>
                        <el-switch v-model="display" active-text="瀑布流展示" inactive-text="分页展示" :active-value="true"
                            :inactive-value="false" @change="handleDisplayChange" style="padding-bottom: 1rem;">
                        </el-switch>
                    </el-card>
                    <!-- <el-text>功能升级中，后两个选项暂时无法使用</el-text><br> -->

                    <!-- <el-switch v-model="limit" active-text="（？）" inactive-text="全年龄向" :active-value="true"
                        :inactive-value="false" @change="handleLimitChange" style="padding-bottom: 1rem;">
                    </el-switch>
                    <br>
                    <el-switch v-model="like" active-text="只看精选" inactive-text="展示全部" :active-value="true"
                        :inactive-value="false" @change="handleLikeChange" style="padding-bottom: 1rem;">
                    </el-switch> -->
                    <Waterfall :list="gallery_w" :breakpoints="breakpoints" :gutter="0" v-if="waterfallVisible">
                        <template #item="{ item, index }">
                            <el-card shadow="hover" style="text-align: center;" :body-style="{ padding: '0px' }">
                                <el-image style="width: 100%" :src="item" @click="handleClick(index)">
                                    <template #error>
                                        <div
                                            style="width: 100%; height: 100%; background:#f5f5f5; display: grid; place-items: center;">
                                            <el-button type="primary" size="small"
                                                @click="reloadSingleImage(item, index)"><i
                                                    class="fa fa-arrow-rotate-right" /></el-button>
                                        </div>
                                    </template>
                                </el-image>
                                <i class="fa-solid fa-heart" style="font-size:1.5rem;color:#FF698C;position:absolute;right:
                                    1rem;top:1rem" v-show="item.includes('-h')" />
                            </el-card>
                        </template>
                    </Waterfall>
                    <el-image-viewer v-if="showPreview" :url-list="gallery" show-progress :initial-index="showIndex"
                        @close="showPreview = false" />
                    <div v-if="pageVisible">
                        <div class="row">
                            <el-card class="col-6 col-xl-3" shadow="hover"
                                style="text-align: center;position: relative;" v-for="(item, index) in gallery"
                                :body-style="{ padding: '0px' }">
                                <!-- <img :src="require('img/' + item)" style="width: 100%" loading="lazy" /> -->
                                <el-image style="width: 100%" :src="item" :preview-src-list="gallery" show-progress
                                    :initial-index="index" fit="cover">
                                    <template #error>
                                        <div
                                            style="width: 100%; height: 100%; background:#f5f5f5; display: grid; place-items: center;">
                                            <el-button type="primary" size="small"
                                                @click="reloadSingleImage(item, index)"><i
                                                    class="fa-solid fa-arrow-rotate-right" /></el-button>
                                        </div>
                                    </template>
                                </el-image>
                                <i class="fa-solid fa-heart" style="font-size:1.5rem;color:#FF698C;position:absolute;right:
                                    1rem;top:1rem" v-show="item.includes('-h')" />
                            </el-card>
                        </div>
                        <nav>
                            <div class="pagination-container">
                                <el-pagination layout="prev, pager, next" :page-size="perpage" :total="totalNum"
                                    @current-change="handleCurrentChange" :current-page="page">
                                </el-pagination>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script setup>
import { Waterfall, LazyImg } from 'vue-waterfall-plugin-next'
import 'vue-waterfall-plugin-next/dist/style.css'
import Header from '../components/Header.vue'
import { onMounted, ref } from 'vue'
import axios from 'axios'
import { useCache } from '../utils/usecache'

const title = '图库';
const subtitle = '烧流量警告';
const gallery = ref();
const gallery_t = ref();
const gallery_w = ref();
const gallery_w_t = ref();
const perpage = 12;
const totalNum = ref();
const page = ref();
page.value = 1;
const limit = ref(false)
const display = ref(false)
const like = ref(false)
const suffixes = ['.jpg', '.jpeg', '.png', '.gif']
// t:thumbnail,g:guro,h:heart,w:waterfall
let ga = [];
let ga_t = [];
let ga_g = [];
let ga_g_t = [];
let ga_h = [];
let ga_h_t = [];
let ga_g_h = [];
let ga_g_h_t = [];
const ga_list = ref();
const ga_list_t = ref();
const ga_g_list = ref();
const ga_g_list_t = ref();
const ga_h_list = ref();
const ga_h_list_t = ref();
const ga_g_h_list = ref();
const ga_g_h_list_t = ref();

const dialogTableVisible = ref(false)
const dialogPic = ref()
const dialogWidth = ref(0)
const showPreview = ref(false)
const showIndex = ref(0)
const waterfallVisible = ref(false)
const pageVisible = ref(true)
const breakpoints = {
    10000: { //当屏幕宽度小于等于1200
        rowPerView: 4,
    },
    700: { //当屏幕宽度小于等于500
        rowPerView: 2,
    }
}

// const getData = () => {
//     let g = Object.values(require.context("img", true, /^.\/gallery_/).keys());

//     // ga全0全图鉴 ga_g非全0全图鉴
//     // ga_h全0仅收藏 ga_g_h非全0仅收藏
//     for (let j of g) {
//         let q = j.replace(/^.\//, '');
//         if (j.includes('-g')) {
//             if (j.includes('-h')) {
//                 ga_g_h.push(require(`img/${q}`));
//                 ga_g_h_t.push(require(`img/thumbnail/${q}`));
//             } else {
//                 ga_g.push(require(`img/${q}`));
//                 ga_g_t.push(require(`img/thumbnail/${q}`));
//             }
//         } else {
//             if (j.includes('-h')) {
//                 ga_g_h.push(require(`img/${q}`));
//                 ga_h.push(require(`img/${q}`));
//                 ga_g.push(require(`img/${q}`));
//                 ga.push(require(`img/${q}`));
//                 ga_g_h_t.push(require(`img/thumbnail/${q}`));
//                 ga_h_t.push(require(`img/thumbnail/${q}`));
//                 ga_g_t.push(require(`img/thumbnail/${q}`));
//                 ga_t.push(require(`img/thumbnail/${q}`));
//             } else {
//                 ga_g.push(require(`img/${q}`));
//                 ga.push(require(`img/${q}`));
//                 ga_g_t.push(require(`img/thumbnail/${q}`));
//                 ga_t.push(require(`img/thumbnail/${q}`));
//             }
//         }
//     }
//     ga = ga.reverse();
//     ga_g = ga_g.reverse();
//     ga_h = ga_h.reverse();
//     ga_g_h = ga_g_h.reverse();

//     ga_t = ga_t.reverse();
//     ga_g_t = ga_g_t.reverse();
//     ga_h_t = ga_h_t.reverse();
//     ga_g_h_t = ga_g_h_t.reverse();

//     ga_list.value = ga
//     ga_g_list.value = ga_g
//     ga_h_list.value = ga_h
//     ga_g_h_list.value = ga_g_h
//     gallery_w.value = ga;
//     gallery.value = ga.slice((page.value - 1) * perpage, page.value * perpage);
//     totalNum.value = ga.length;

//     ga_list_t.value = ga_t
//     ga_g_list_t.value = ga_g_t
//     ga_h_list_t.value = ga_h_t
//     ga_g_h_list_t.value = ga_g_h_t
//     gallery_w_t.value = ga_t;
//     gallery_t.value = ga_t.slice((page.value - 1) * perpage, page.value * perpage);

// }



const getData = async () => {
    try {
        const res = await useCache('galleryList', () => {
            return axios.get('/gallery/').then(res => res.data)
        })
        if (res && Array.isArray(res)) {
            ga.value = res.filter(item => {
                if (item.type !== 'file') return false;
                const suffix = item.name.slice(item.name.lastIndexOf('.')).toLowerCase();
                return suffixes.includes(suffix);
            }).map(item => { return 'http://img.helloworldend.top/gallery/' + item.name }).reverse()
            gallery.value = ga.value.slice((page.value - 1) * perpage, page.value * perpage);
            gallery_w.value = ga.value;
            totalNum.value = ga.value.length;
        }
    } catch (error) {
        console.error('获取图片列表失败：', error)
    }
}

onMounted(() => {
    getData()
})

const handleCurrentChange = (val) => {
    if (limit.value && !like.value) {
        gallery.value = ga_g.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_g.length;
        gallery_t.value = ga_g_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else if (limit.value && like.value) {
        gallery.value = ga_g_h.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_g_h.length;
        gallery_t.value = ga_g_h_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else if (!limit.value && !like.value) {
        gallery.value = ga.value.slice((val - 1) * perpage, val * perpage);
        // gallery_t.value = ga_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else {
        gallery.value = ga_h.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_h.length;
        gallery_t.value = ga_h_t.slice((page.value - 1) * perpage, page.value * perpage);
    }
    page.value = val;
}

const handleLimitChange = (val) => {
    limit.value = val;
    if (limit.value && !like.value) {
        gallery_w.value = ga_g;
        gallery.value = ga_g.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_g.length;
        gallery_w_t.value = ga_g_t;
        gallery_t.value = ga_g_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else if (limit.value && like.value) {
        gallery_w.value = ga_g_h;
        gallery.value = ga_g_h.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_g_h.length;
        gallery_w_t.value = ga_g_h_t;
        gallery_t.value = ga_g_h_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else if (!limit.value && !like.value) {
        gallery_w.value = ga;
        gallery.value = ga.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga.length;
        gallery_w_t.value = ga_t;
        gallery_t.value = ga_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else {
        gallery_w.value = ga_h;
        gallery.value = ga_h.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_h.length;
        gallery_w_t.value = ga_h_t;
        gallery_t.value = ga_h_t.slice((page.value - 1) * perpage, page.value * perpage);
    }
}

const handleDisplayChange = (val) => {
    display.value = val;
    if (display.value) {
        waterfallVisible.value = true;
        pageVisible.value = false;
    } else {
        waterfallVisible.value = false;
        pageVisible.value = true;
    }
}

const handleLikeChange = (val) => {
    like.value = val;
    if (limit.value && !like.value) {
        gallery_w.value = ga_g;
        gallery.value = ga_g.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_g.length;
        gallery_w_t.value = ga_g_t;
        gallery_t.value = ga_g_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else if (limit.value && like.value) {
        gallery_w.value = ga_g_h;
        gallery.value = ga_g_h.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_g_h.length;
        gallery_w_t.value = ga_g_h_t;
        gallery_t.value = ga_g_h_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else if (!limit.value && !like.value) {
        gallery_w.value = ga;
        gallery.value = ga.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga.length;
        gallery_w_t.value = ga_t;
        gallery_t.value = ga_t.slice((page.value - 1) * perpage, page.value * perpage);
    } else {
        gallery_w.value = ga_h;
        gallery.value = ga_h.slice((page.value - 1) * perpage, page.value * perpage);
        totalNum.value = ga_h.length;
        gallery_w_t.value = ga_h_t;
        gallery_t.value = ga_h_t.slice((page.value - 1) * perpage, page.value * perpage);
    }
}

const handleClick = (index) => {
    showPreview.value = true
    showIndex.value = index
}

const reloadSingleImage = (item, index) => {
    gallery.value[index] = item + (item.includes('?') ? '&' : '?') + '_t=' + Date.now()
}


const download = (index) => {
    const url = srcList[index]
    const suffix = url.slice(url.lastIndexOf('.'))
    const filename = Date.now() + suffix

    fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
            const blobUrl = URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')
            link.href = blobUrl
            link.download = filename
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(blobUrl)
            link.remove()
        })
}


// const handleClick = (item) => {
//     dialogTableVisible.value = true
//     dialogPic.value = item;
//     setDialogWidth()
// }

// const setDialogWidth = () => {
//     var val = document.body.clientWidth
//     const def = 800 // 默认宽度
//     if (val < def) {
//         dialogWidth.value = '95%'
//     } else {
//         dialogWidth.value = def + 'px'
//     }
// }
</script>